document.addEventListener('DOMContentLoaded', () => {
    initCartProgressBar();
    observeCartChanges();
});

// Watch for cart changes via events
['cart:updated', 'cart:item-added', 'cart:item-removed', 'change'].forEach(event => {
    document.addEventListener(event, () => {
        // Debounce slightly to allow Dawn's section rendering to finish
        setTimeout(initCartProgressBar, 500);
    });
});

function observeCartChanges() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(node => {
                    if (node.id === 'CartProgressBar' || (node.querySelector && node.querySelector('#CartProgressBar'))) {
                        initCartProgressBar();
                    }
                });
            }
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

function initCartProgressBar() {
    const bars = document.querySelectorAll('.cart-progress-bar-container');
    bars.forEach(progressBar => {
        const count = parseInt(progressBar.dataset.shirtCount || '0');
        const goal1 = parseInt(progressBar.dataset.goal1 || '2');
        const goal2 = parseInt(progressBar.dataset.goal2 || '3');
        const fill = progressBar.querySelector('.cart-progress-bar__fill');

        if (fill) {
            let percent = 0;
            let startQty = 0;
            let endQty = goal1;
            let currentPhase = 1;

            if (goal2 > goal1 && count > goal1) {
                currentPhase = 2;
                startQty = goal1;
                endQty = goal2;
                progressBar.classList.remove('phase-1');
                progressBar.classList.add('phase-2');
                progressBar.setAttribute('data-phase', '2');
            } else {
                progressBar.classList.remove('phase-2');
                progressBar.classList.add('phase-1');
                progressBar.setAttribute('data-phase', '1');
            }

            if (count > startQty) {
                if (count >= endQty) {
                    percent = 100;
                } else {
                    const relativeCount = count - startQty;
                    const relativeTotal = endQty - startQty;
                    percent = (relativeCount / relativeTotal) * 100;
                }
            }

            requestAnimationFrame(() => {
                fill.style.width = `${percent}%`;
            });
        }

        const markers = progressBar.querySelectorAll('.cart-progress-bar__marker');
        markers.forEach(m => {
            const markerQty = parseInt(m.dataset.qty || '0');

            if (count >= markerQty) {
                if (!m.classList.contains('is-reached')) {
                    m.classList.add('is-reached', 'pop-animation');
                    setTimeout(() => m.classList.remove('pop-animation'), 600);
                }
            } else {
                m.classList.remove('is-reached', 'pop-animation');
            }
        });
    });
}
